import { render, staticRenderFns } from "./PartnerSiteNoteModal.vue?vue&type=template&id=85223e7a&"
import script from "./PartnerSiteNoteModal.vue?vue&type=script&lang=js&"
export * from "./PartnerSiteNoteModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports